import { getExportFileApiBaseUrl } from '@/shared/utils/helpers';
import Vue from 'vue';
/**
 * Link de download do arquivo final de uma exportação de planilha.
 *
 * A flag `new_export_modal` do `user` e o `filesUrl` (o `context.filesUrl` da
 * notificação / `params.fileUrl` do evento) decidem para qual API perguntar:
 * quem gerou o arquivo é quem consegue assinar a URL. Sem os dois, vale o
 * Api-Export, como antes.
 */
export async function getFileUrl(eventId, filesUrl, user) {
    return await Vue.axios.get(`${getExportFileApiBaseUrl(filesUrl, user)}/export/file_url?eventId=${eventId}&skip_handle_error`);
}
